const userManagementConstantsEn = {
  userManagement: 'User Management',
};

export default userManagementConstantsEn;
